import UploadFilesSummaryAdmin from "./UploadFilesSummaryAdmin";
import FeedbackComponent from "../ResponsiveEvent.jsx/FeedbackComponent";
import useGetFormContext from "./useFormAdminContext";
import SurveyResponse from "./SurveyResponse.jsx";
import KeyInformation from "../ResponsiveEvent.jsx/KeyInformation.jsx";
import TotalAttendeesAdmin from "./TotalAttendeesAdmin.js";

const SummaryAdmin = () => {
  const { eventFormData } = useGetFormContext();

  const content = (
    <>
      <div className="col-md-10 mb-3">
        {/* Key Information */}
        <div className="container bg-light rounded p-2 mt-2 mb-1">
          <KeyInformation eventId={eventFormData.eventId} />
          <TotalAttendeesAdmin></TotalAttendeesAdmin>
        </div>
        {/*Survey Response */}
        {eventFormData.mltEvent && <SurveyResponse />}

        {/* feedback */}
        <FeedbackComponent eventId={eventFormData.eventId} />

        {/* files upload and display  */}
        <UploadFilesSummaryAdmin></UploadFilesSummaryAdmin>
        <div style={{ height: "100px" }}></div>
      </div>
    </>
  );
  return content;
};

export default SummaryAdmin;